import { render, staticRenderFns } from "./approvalFlow.vue?vue&type=template&id=3c8aa814"
import script from "./approvalFlow.vue?vue&type=script&lang=js"
export * from "./approvalFlow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports